import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { AutomationSearchResult } from '../types/Automations'

interface GetFieldValuesResponse {
    AVAILABLE_FILTER_FIELD_VALUES: Array<{
        localeKey: string
        referenceKey: string
        value: string
    }>
}

interface UseFieldQueryProps {
    fieldEId: string
    page: number
    perPage: number
    query: string
    companyEId: string
    automationType: string
    companyAutomation: AutomationSearchResult
    triggerType: string
}

export default function useFieldQuery({
    fieldEId,
    page,
    perPage,
    query,
    companyEId,
    automationType,
    companyAutomation,
    triggerType
}: UseFieldQueryProps) {
    return useQuery({
        queryKey: ['automation/field/values', fieldEId, page, perPage, query, automationType, triggerType],
        queryFn: async () => {
            const GET_AUTOMATION_FILTER_VALUES = `/admin/action/automation/admin/filter/${fieldEId}/values`;
            return axios.post<GetFieldValuesResponse>(GET_AUTOMATION_FILTER_VALUES, { ...companyAutomation,
            automationType: companyAutomation.automationType || automationType, triggerType}, {
                params: {
                    companyEId,
                    automationType,
                    triggerType,
                    start: page + 1,
                    count: perPage,
                }
            })
        },
    })
}
